export default __webpack_public_path__ + "static/media/arrow.90a3de8f.svg";